const trustSrc = ["$sce", function ($sce) {
  return function (src) {
    return $sce.trustAsResourceUrl(src);
  };
}]

export { trustSrc }
